export default 'marketing-integration-component';
export const GMB_APP = 'google-my-business-app';
